export const helpStyle = {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 8,
    fontSize: 14
}